

module.exports = angular.module('msi.spinner', []).name;

angular.module(module.exports)
  .directive('ogSpinner', require('./spinner'))
  .component('ogSpinnerOverlay', require('./overlay'));
